import Logo from '../../../public/images/logos/logo_horizontal.png';
import Image from 'next/image';
import styles from './ChooseStep.module.css';
import { UploadButtonWrapper } from '../UploadButton/UploadButtonWrapper';
import VideoIcon from '../../../public/images/icons/video.svg';
import PhotoIcon from '../../../public/images/icons/photo.svg';
import useTranslation from 'next-translate/useTranslation';

export const ChooseStep = () => {
    const { t } = useTranslation('create');

    return (
        <div className="max-w-[526px] mx-auto">
            <h1 className={styles.create_caption}>
                <Image width={160} height={60} src={Logo} priority alt="Tutu Porn Logo" />
                <span>{t('title')}</span>
            </h1>
            
            <div className="flex flex-col sm:flex-row w-full gap-x-4 gap-y-4">
                <UploadButtonWrapper 
                    inputProps={{
                        multiple: false,
                        accept: "image/*,video/*"
                    }}
                    button={t('chooseStep.singleButton')}
                    icon={<VideoIcon className="h-8 w-8 text-primary" />} 
                    label={`${t('video')}/${t('photo')}`}
                    description={<>{t('chooseStep.singleSubtitle1')} <br />{t('chooseStep.singleSubtitle2')}</>} />

                <UploadButtonWrapper
                    inputProps={{
                        multiple: true,
                        accept: "image/*,video/*"
                    }}
                    button={t('chooseStep.multipleButton')}
                    icon={<PhotoIcon className="h-8 w-8 text-primary" />}
                    label={t('gallery')}
                    description={<>{t('chooseStep.multipleSubtitle')}</>} />
            </div>
        </div>
    )
}